// import axios from "axios";
import { createBoApiClient } from "@/services/boApiHttp";

const siteCode = process.env.NEXT_PUBLIC_SITE_CODE;
// const http = axios.create({ baseURL: process.env.NEXT_PUBLIC_BO_API });
const http = createBoApiClient();

export const EnquiryTypes = {
  common: 1,
  flightAndHotel: 2,
  flight: 3,
  hotel: 4,
  deal: 5,
  generalQuote: 6,
  offer: 7,
  promotion: 8,
  search: 9,
  flashDeals: 10,
  wfvFlashDeals: 11,
  socialOffer: 12,
  contactUs: 13,
  hotDeals: 14,
  latestFlightDealsAndOffers: 15,
  googleLeads: 16,
  activity: 17,
  transfer: 18,
  callOrMail: 19,
  cruise: 20,
} as const;

export type EnquiryType = (typeof EnquiryTypes)[keyof typeof EnquiryTypes];

export interface EnquiryEmail {
  enquiryTypes?: EnquiryType[];
  holderDetail: EnquiryHolderDetail;
  flyingFrom?: string;
  flyingTo?: string;
  departureDate?: string;
  returnDate?: string;
  cabinClass?: string;
  airline?: string;
  flyingType?: string;
  personCount?: number;
  nightStayCount?: string | number;
  currency?: string;
  price?: string | number;
  totalCharge?: string;
  flyerNo?: string;
  flyerProgram?: string;
  mealRequest?: string;
  dateOfBirth?: string;
  seatRequest?: string;
  specialRequest?: string;
  specialOccasion?: string;
  dealId?: number | string | null;
  slug?: string;
  dealTitle?: string;
  dealDate?: string;
  message?: string;
  installmentStatus?: string;
  installmentPercentage?: number | null;
  rooms?: EnquiryRoom[];
  destinationWithNights?: EnquiryDestinationWithNight[];
  cruises?: EnquiryCruise[];
  pageUrl?: string;
  marketingAgent?: string;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
  utmContent?: string | null;
  remark?: string;
  countryCode?: string | null | undefined;
  sendEmail?: boolean;
  isPpc?: boolean | null;
}

export interface EnquiryCruise {
  startAt: string;
  startDate: string;
  endsAt: string;
  endDate: string;
  cruiseReference: string;
  cruiseName: string;
  shipName: string;
  operatorName: string;
  cruiseRate: string;
  fareAvailability: string;
  cruiseNights: number;
  vacationDays: number;
  cruiseTypes: string[];
  regions: string[];
  travelType: string;
  totalCharge: string;
  adultCount?: number;
  childCount?: number;
  currency?: string;
  fareGradeName?: string;
  fareGradeCode?: string;
  fareSetName?: string;
  fareSetDealCode?: string;
  adultPassengers?: EnquiryCruisePassenger[];
  childPassengers?: EnquiryCruisePassenger[];
}

export interface EnquiryCruisePassenger {
  type: string;
  title: string;
  firstName: string;
  lastName?: string;
  gender: string;
  dateOfBirth: string;
}

interface EnquiryRoom {
  adult?: number;
  youth?: number;
  children?: number;
  childrenAges?: string[];
  infant?: number;
  boardType?: string | null;
  facilities?: string[];
}

interface EnquiryHolderDetail {
  name: string;
  email: string | null;
  phone: string | null;
  callBackMode?: string | null;
  communicationPlatform?: string | null;
  callBackTime?: string | null;
  address?: string | null;
}

export interface EnquiryDestinationWithNight {
  destination?: string | undefined;
  noOfNights?: string | number | undefined;
}

export const enquiryEmail = (data: EnquiryEmail) =>
  http.post("/public/v2/inquiries", {
    ...data,
    siteCode,
  });
